import React, { useContext } from 'react';
import { useNavigate } from 'react-router';
import { VERIFY_RECOVERY_CODE } from '@/constants/routes';
import { VERIFY_RECOVERY_CODE_MUTATION } from '@/api/mutations';
import { VerifyRecoveryCodeData } from './VerifyRecoveryCodeForm';
import { useMutation } from '@apollo/client';
import { CREATE_PASSWORD } from '../../../../constants/routes';

const useVerifyRecoveryCodeRequest = () => {
    const navigate = useNavigate();
    const [ verifyRecoveryCode ] = useMutation(VERIFY_RECOVERY_CODE_MUTATION)


    const handleVerifyRecoveryCode = async (values: VerifyRecoveryCodeData, setError: (error: string) => void) => {
        const variables = { ...values, code: Number(values.code.join('')) };

        try {
            const req = await verifyRecoveryCode({ variables });

            if (req.data?.verifyRecoveryCode?.message) {
                if (req.data.verifyRecoveryCode.__typename == "ErrorType") return setError(req.data?.verifyRecoveryCode?.message);
    
                return navigate(CREATE_PASSWORD, { state: variables });
                
            }
            if (req.errors) {
                setError(req.errors.toString());
            }
    
        } catch (e){
            setError(String(e))
        }
    }

    return {
        verifyRecoveryCode: handleVerifyRecoveryCode
    }
}

export default useVerifyRecoveryCodeRequest;